import { MenuItem } from '@mui/material';
import { Add as AddIcon, FileUpload as FileUploadIcon } from '@mui/icons-material';

import {
  CustomAutoComplete,
  CustomButton,
  CustomSelect,
  HorizontalForm,
} from '../../../../common/components';
import { ADJUSTMENT_TYPE_OPTIONS, compactFormSx } from '../../constants/supplierLedgerUiConstants';

const selectFilterSx = {
  width: 198,
  flex: '0 0 198px',
  mt: 0,
};

const AdjustmentsToolbar = ({
  filters,
  onChange,
  onOpenDrawer,
  onOpenImport,
  providerOptions,
}) => (
  <HorizontalForm withBorder={false} sx={{ ...compactFormSx, alignItems: 'flex-start' }}>
    <CustomButton variant="base" startIcon={<AddIcon />} onClick={onOpenDrawer}>Nuevo ajuste</CustomButton>
    <CustomButton variant="outlined" startIcon={<FileUploadIcon />} onClick={onOpenImport}>Importar saldos</CustomButton>
    <CustomAutoComplete
      label="Proveedor"
      name="uuid_legal_entity"
      value={filters.uuid_legal_entity}
      onChange={onChange}
      options={[{ value: '', label: 'Todos' }, ...providerOptions]}
      sx={{ width: 288, flex: '0 0 288px', mt: 0 }}
    />
    <CustomSelect label="Tipo" name="adjustment_type" value={filters.adjustment_type} onChange={onChange} displayEmpty sx={selectFilterSx}>
      <MenuItem value="">Todos</MenuItem>
      {ADJUSTMENT_TYPE_OPTIONS.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
    </CustomSelect>
    <CustomSelect label="Estado" name="status" value={filters.status} onChange={onChange} displayEmpty sx={{ ...selectFilterSx, width: 162, flex: '0 0 162px' }}>
      <MenuItem value="">Todos</MenuItem>
      <MenuItem value="active">Activo</MenuItem>
      <MenuItem value="cancelled">Anulado</MenuItem>
    </CustomSelect>
  </HorizontalForm>
);

export default AdjustmentsToolbar;
